
/* ------------------------------------------------------------------------------
 *
 *  # Bars with line for TEAMS
 *
 * ---------------------------------------------------------------------------- */


var PromanaBarsLineLight__TEAMS = function() {

    var _promanaChartLineBars__TEAMS = function(args) {

        if (typeof echarts == 'undefined') {
            console.warn('Warning - echarts.min.js is not compiled');
            return;
        }

        var bars_mix_element = document.getElementById(args.anchor);

        if (bars_mix_element) {

            var bars_mix = echarts.init(bars_mix_element);

            bars_mix.setOption({

                textStyle: {
                    fontFamily: 'Roboto, Arial, Verdana, sans-serif',
                    fontSize: args.fontsize.global
                },

                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: args.legend,
                grid: args.grid,
                xAxis: args.x_axis,
                yAxis: args.y_axis,
                series: args.series,
                f_slugs: args.factor_slugs,

            });
        }

        var opts = bars_mix.getOption();

        var toggleLegendName = function(legendName) {
            if( $.inArray(legendName,ignoreLegend) == -1){
                bars_mix.dispatchAction({
                    type: 'legendToggleSelect',
                    name: legendName
                });
            }
        };

        $('.choosing-respondent').on('change',function(){
            toggleLegendName( $(this).next().html() );
        });

        bars_mix.on('legendselectchanged', params => {
            var isSelected = params.selected[params.name];
            var chkbox = $("input[legend='"+params.name+"']");
            chkbox.prop("checked", isSelected);
            updateSummaryList(
                params.name,
                isSelected,
                chkbox.attr("uuid")
                );
            setTabState( chkbox.attr('uuid'), isSelected );
        });

        bars_mix.on('click', params => {
            if(params.targetType === "axisLabel"){
                $("#per-factor-chart-"+opts.f_slugs[params.value]).modal("show");
            }
        });

        // Resize function
        var triggerChartResize = function() {
            bars_mix_element && bars_mix.resize();
        };

        // On sidebar width change
        var sidebarToggle = document.querySelectorAll('.sidebar-control');
        if (sidebarToggle) {
            sidebarToggle.forEach(function(togglers) {
                togglers.addEventListener('click', triggerChartResize);
            });
        }

        // On window resize
        var resizeCharts;
        window.addEventListener('resize', function() {
            clearTimeout(resizeCharts);
            resizeCharts = setTimeout(function () {
                triggerChartResize();
            }, 200);
        });
    };

    return {
        init: function(args) {
            _promanaChartLineBars__TEAMS(args);
        }
    }
}();
